import toast from 'jquery-toast-plugin';

/*
 * 応募
 */

jQuery(function () {
  $('.reservation-btn').on('click', function () {
    // プレビュー時動作させない
    var url = location.href ;
    if ( url.indexOf('preview') !== -1) {
        return false;
    }
    var post_data = {};
    post_data['event_id'] = $(this).data('event_id');

    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });
    $.ajax({
      url: '/ajax/reservations/update',
      type: 'POST',
      dataType: 'json',
      data: post_data
    })
      // Ajaxリクエストが成功した時発動
      .done((data) => {
        if (data['result'] == 'cancel') {

            $('.event_id' + post_data['event_id']).removeClass('push');
            $('.event_id' + post_data['event_id']).find('svg').attr('data-prefix', 'far');

          $.toast({
            heading: 'キャンセルしました',
            text: 'キャンセルしました',
            showHideTransition: 'slide',
            icon: 'success',
            position: 'bottom-right',
            hideAfter: 6000
          });
        } else if (data['result'] == 'reservation') {

            $('.event_id' + post_data['event_id']).find('svg').attr('data-prefix', 'fas');
            $('.event_id' + post_data['event_id']).addClass('push');

          $.toast({
            heading: '応募しました',
            text: '応募しました',
            showHideTransition: 'slide',
            icon: 'success',
            position: 'bottom-right',
            hideAfter: 6000
          });

        } else if (data['result'] == 'nologin') {

          $.toast({
            heading: 'ログインしていません',
            text: 'ログインしていません',
            showHideTransition: 'slide',
            icon: 'info',
            position: 'bottom-right',
            hideAfter: 6000
          });
        } else if (data['result'] == 'create_ng') {

          $.toast({
            heading: '応募登録に失敗しました',
            text: 'お手数ですが、再度応募してください',
            showHideTransition: 'slide',
            icon: 'error',
            position: 'bottom-right',
            hideAfter: 6000
          });

        } else if (data['result'] == 'sendmail_ng') {

          $.toast({
            heading: '応募メール送信に失敗しました',
            text: '応募メール送信に失敗しました',
            showHideTransition: 'slide',
            icon: 'error',
            position: 'bottom-right',
            hideAfter: 6000
          });

        }

      })
      // Ajaxリクエストが失敗した時発動
      .fail((data) => {

        $.toast({
          heading: '応募登録に失敗しました',
          text: 'お手数ですが、再度応募してください',
          showHideTransition: 'slide',
          icon: 'error',
          position: 'bottom-right',
          hideAfter: 6000
        });
      })
      // Ajaxリクエストが成功・失敗どちらでも発動
      .always((data) => {

      });
  });
});
